import { Component, Input, OnInit } from '@angular/core';
import { DecimalFormatPipe } from '../../../../../../shared';
import { pessoaCentralCompras } from '../../../pessoa-tipo';

interface Config {
    titleHint: string;
}

@Component({
    selector: 'sgt-pessoa-tipo-badge-central-compras',
    templateUrl: './pessoa-tipo-badge-central-compras.component.html',
    styleUrls: ['./pessoa-tipo-badge-central-compras.component.less']
})
export class PessoaTipoBadgeCentralComprasComponent implements OnInit {
    config: Config;
    tipo = pessoaCentralCompras;
    @Input() quantidadeParticipantes: number = null;

    constructor(private decimalFormatPipe: DecimalFormatPipe) { }

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            titleHint: this.quantidadeParticipantes > 0 ? `${this.tipo.nome} com ${this.decimalFormatPipe.transform(this.quantidadeParticipantes, 1, 0, 0)} participante(s)` : this.tipo.nome
        };
    }
}
